(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["raciety-fit-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (scope) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-raciety-fit-carousel]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-raciety-fit-carousel]'));
    roots.forEach((root) => {
      if (root.dataset.fitReady === 'true') return;
      root.dataset.fitReady = 'true';
      const track = root.querySelector('[data-fit-track]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const videos = [...root.querySelectorAll('.raciety-fit__video')];
      videos.forEach((video) => {
        const button = video.parentElement.querySelector('[data-fit-toggle]');
        const updateButton = () => {
          if (!button) return;
          const playing = !video.paused && !video.ended;
          button.dataset.playing = playing ? 'true' : 'false';
          button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        };
        video.addEventListener('play', updateButton);
        video.addEventListener('pause', updateButton);
        updateButton();
        if (button) {
          button.addEventListener('click', () => {
            if (video.paused) {
              video.dataset.userPaused = 'false';
              video.play().catch(() => {});
            } else {
              video.dataset.userPaused = 'true';
              video.pause();
            }
          });
        }
      });
      if ('IntersectionObserver' in window && !reduceMotion) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && video.dataset.userPaused !== 'true') {
              video.play().catch(() => {});
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          });
        }, { threshold: 0.6 });
        videos.forEach((video) => observer.observe(video));
      }
      root.querySelectorAll('[data-fit-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!track) return;
          const direction = Number(button.dataset.fitScroll) || 1;
          track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  } else {
    mount(document);
  }
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
